/**
 * Edit Node Component
 *
 * Node for editing existing images based on prompts.
 */

import { memo } from 'react';
import { type NodeProps } from '@xyflow/react';
import { BaseNode } from './BaseNode';
import type { NodeData } from '@/types/imageWorkflow';

const EditNodeComponent = ({ id, data, selected }: NodeProps) => {
  const nodeData = data as NodeData;

  return (
    <BaseNode id={id} data={nodeData} type="edit" selected={selected}>
      {nodeData.prompt ? (
        <div className="space-y-1">
          <div className="text-gray-500">Edit prompt:</div>
          <div className="line-clamp-2 text-gray-700">{String(nodeData.prompt)}</div>
          {nodeData.model && nodeData.model !== 'auto' && (
            <div className="text-gray-400 mt-1">Model: {String(nodeData.model)}</div>
          )}
        </div>
      ) : (
        <div className="text-gray-400 italic">Click to configure edit</div>
      )}
    </BaseNode>
  );
};

export const EditNode = memo(EditNodeComponent);
export default EditNode;
